import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  showRank?: number;
  compact?: boolean;
}

export default function MediaCard({ item, showRank, compact = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      title={`${item.title} - 光棍影院`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}（${item.genre.join("、")}）影视封面`}
          title={`${item.title} - 光棍影院`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-80" />

        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {showRank !== undefined && (
            <span className="px-2 py-0.5 rounded-md text-xs font-bold bg-primary-500 text-background-50">
              {showRank}
            </span>
          )}
          <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-foreground-950/70 text-background-50 backdrop-blur-sm">
            {item.type === "movie" ? "电影" : "电视剧"}
          </span>
        </div>

        {item.tags && item.tags.length > 0 && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-xs font-semibold bg-red-600 text-white">
            {item.tags[0]}
          </span>
        )}

        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="flex items-center gap-1 text-xs font-semibold text-accent-400">
            <i className="ri-star-fill text-sm"></i>
            {item.rating.toFixed(1)}
          </span>
          <span className="text-xs text-background-200">{item.year}</span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-accent-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-2xl text-foreground-950"></i>
          </span>
        </div>
      </div>

      <div className={compact ? "mt-2" : "mt-2.5"}>
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5 truncate">
          {item.genre.slice(0, 2).join(" · ")} · {item.region}
        </p>
        {!compact && (
          <p className="text-xs text-foreground-400 mt-1 flex items-center gap-1">
            <i className="ri-time-line"></i>
            更新于 {item.updatedAt}
          </p>
        )}
      </div>
    </Link>
  );
}